import {Baseline} from '../../../allkeyme/workingdata/message/Baseline';
import {BaselineLite} from '../../../allkeyme/workingdata/message/BaselineLite';
import {BaselineValue} from '../../../allkeyme/workingdata/message/BaselineValue';
import {BaselineValueLite} from '../../../allkeyme/workingdata/message/BaselineValueLite';
import {EntityModificationTrace} from '../parameters/EntityModificationTrace';

export class DataPackSet {
baselineValues: BaselineValue[];
baselines: Baseline[];
deleted: EntityModificationTrace[];
level: number | null;
remoteBaselineValues: BaselineValueLite[];
remoteBaselines: BaselineLite[];
revNumber: number | null;
scenario: string;
}

